import { useState } from "react";

const CALENDLY_URL = "https://calendly.com/hello-krystaldaniellecoaching/1hr";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch("https://readdy.ai/api/form/d77lerqqo7glkto3eaug", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-parchment py-14">
      <div className="max-w-6xl mx-auto px-6">

        {/* Stay in Touch */}
        <div className="text-center mb-12 pb-12 border-b border-sand/50">
          <p className="font-sans text-xs tracking-widest2 uppercase text-ink mb-3">Stay in Touch</p>
          <p className="font-serif text-lg font-light text-ink mb-6">
            Quiet updates, only when it matters.
          </p>
          {submitted ? (
            <p className="font-sans text-sm text-ink">Thank you — you&apos;re on the list.</p>
          ) : (
            <form
              data-readdy-form
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
            >
              <input
                type="email"
                name="email"
                required
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full sm:flex-1 bg-white border border-sand text-ink font-sans text-sm px-4 py-3 rounded-md outline-none focus:border-ink transition-colors placeholder:text-ink/40"
              />
              <button
                type="submit"
                disabled={loading}
                className="whitespace-nowrap font-sans text-xs tracking-widest uppercase bg-ink text-cream px-6 py-3 rounded-md cursor-pointer hover:bg-ink/80 transition-colors disabled:opacity-50"
              >
                {loading ? "Sending..." : "Subscribe"}
              </button>
            </form>
          )}
        </div>

        <div className="flex flex-col md:flex-row items-center justify-between gap-8">

          {/* Logo */}
          <a href="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/e9a4567e546d09965afddf52525e12f0/1d3289ddd0fca10d68734e80484b4f51.png"
              alt="Your Next Move Coaching"
              className="h-8 w-auto object-contain"
            />
          </a>

          {/* Links */}
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-8">
            <a href="#for-you" className="font-sans text-xs tracking-widest uppercase text-ink hover:text-ink transition-colors cursor-pointer whitespace-nowrap">
              Who It&apos;s For
            </a>
            <a href="#gain" className="font-sans text-xs tracking-widest uppercase text-ink hover:text-ink transition-colors cursor-pointer whitespace-nowrap">
              What You&apos;ll Gain
            </a>
            <a href="#about" className="font-sans text-xs tracking-widest uppercase text-ink hover:text-ink transition-colors cursor-pointer whitespace-nowrap">
              About Me
            </a>
            <a
              href={CALENDLY_URL}
              target="_blank"
              rel="nofollow noreferrer"
              className="font-sans text-xs tracking-widest uppercase text-ink hover:text-ink transition-colors cursor-pointer whitespace-nowrap"
            >
              Book
            </a>
          </div>

          {/* Copyright */}
          <p className="font-sans text-xs text-ink">
            &copy; {new Date().getFullYear()} Your Next Move. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
